#!/usr/bin/env node
import { Command } from 'commander';

import ValidateAuthorCommand from '~/author/validate.command';
import {
  GenerateCommand,
  GenerateAllCommand,
} from '~/generator/generate.command';
import ValidateSeriesCommand from '~/series/validate.command';

const program = new Command();

program.addCommand(ValidateAuthorCommand);
program.addCommand(ValidateSeriesCommand);
program.addCommand(GenerateCommand);
program.addCommand(GenerateAllCommand);

program.parse();
